import React from 'react';

const ErrorText = ({ children }) => {
  return (
    <span style={{ color: 'red', fontSize: '0.9em' }}>
      {children}
    </span>
  );
};

export default ErrorText; 